module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vback8-c143b8d6626541e66562b2fe953f66e2.jpg";